import { createSlice } from "@reduxjs/toolkit";
import { fetchSalesReturnGSTR1 } from "./SalesReturnGSTR1Thunk";

const initialState = {
  data: [],
  loading: false,
  error: null,

  filters: {
    accId: null,
    fromDate: null,
    toDate: null,
  },
};

const slice = createSlice({
  name: "salesReturnGSTR1",
  initialState,

  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },

    // ✅ Useful for clearing data when filters change
    resetData: (state) => {
      state.data = [];
      state.error = null;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchSalesReturnGSTR1.pending, (state) => {
        state.loading = true;
        state.error = null;
      })

      .addCase(fetchSalesReturnGSTR1.fulfilled, (state, action) => {
        state.loading = false;

        // ✅ Ensure safe structure
        state.data = Array.isArray(action.payload)
          ? action.payload
          : [];
      })

      .addCase(fetchSalesReturnGSTR1.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export const { setFilters, resetData } = slice.actions;
export default slice.reducer;